"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionProvider = exports.SessionContext = exports.contextDefaultValues = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const key_1 = require("@/app/shared/helpers/storage/constants/key");
const global_1 = require("@/app/shared/store/global");
const scheduler_1 = require("@/app/SUMO/store/scheduler");
const scheduler_2 = require("@/app/SUMOCEP/store/scheduler");
const query_string_1 = __importDefault(require("query-string"));
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
exports.contextDefaultValues = {};
exports.SessionContext = (0, react_1.createContext)(exports.contextDefaultValues);
/** Auth-related localStorage keys to sync with the extension wrapper. */
const AUTH_STORAGE_KEYS = new Set([
    key_1.StorageKey.SERVER_TYPE,
    key_1.StorageKey.SERVER_ENVIRONMENT,
    key_1.StorageKey.SERVER_SALESFORCE_INSTANCE_URL,
    key_1.StorageKey.SERVER_SALESFORCE_ACCESS_TOKEN,
    key_1.StorageKey.SERVER_SALESFORCE_ACCESS_TOKEN_EXPIRATION,
    key_1.StorageKey.SERVER_SALESFORCE_REFRESH_TOKEN,
    key_1.StorageKey.SERVER_SALESFORCE_REFRESH_TOKEN_EXPIRATION,
    key_1.StorageKey.SERVER_PREFIX,
]);
function collectAuthData() {
    const data = {};
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (!key)
            continue;
        if (key.startsWith('CognitoIdentityServiceProvider') || AUTH_STORAGE_KEYS.has(key)) {
            const value = localStorage.getItem(key);
            if (value !== null)
                data[key] = value;
        }
    }
    return data;
}
const SessionProvider = ({ children }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { search } = (0, react_router_dom_1.useLocation)();
    const { extensionIntegration } = query_string_1.default.parse(search);
    const params = {
        extensionIntegration,
        subject: helpers_1.Storage.Local.get(helpers_1.Storage.Key.SUBJECT) || '',
        recipientsEmails: helpers_1.Storage.Local.get(helpers_1.Storage.Key.RECIPIENTS_EMAILS),
        composeViewId: helpers_1.Storage.Local.get(helpers_1.Storage.Key.COMPOSE_VIEW_ID),
        integration: helpers_1.Storage.Local.get(helpers_1.Storage.Key.INTEGRATION),
    };
    const recipientsEmails = (0, helpers_1.decode_json)(params.recipientsEmails);
    const isAuthorized = (0, react_redux_1.useSelector)(global_1.globalSelectors.selectIsAuthorized);
    const serverType = (0, react_redux_1.useSelector)(global_1.globalSelectors.selectServerType);
    const prevIsAuthorizedRef = (0, react_1.useRef)(isAuthorized);
    (0, react_1.useEffect)(() => {
        dispatch(global_1.globalActions.initializeApp());
    }, [isAuthorized, serverType]);
    (0, react_1.useEffect)(() => {
        if (params.extensionIntegration) {
            dispatch(global_1.globalActions.setExtensionIntegration(params.extensionIntegration));
        }
        if (serverType === "SUMO" /* ServerType.SUMO */) {
            dispatch(scheduler_1.SUMO1SchedulerActions.setSchedulerParams({ ...params, recipientsEmails }));
        }
        else {
            dispatch(scheduler_2.SUMOCEPSchedulerActions.setSchedulerParams({ ...params, recipientsEmails }));
        }
    }, [params]);
    // Sync auth state and data to the extension wrapper.
    (0, react_1.useEffect)(() => {
        if (window.parent === window)
            return;
        helpers_1.ExtensionRuntime.sendMessage({
            type: constants_1.RegularMessage.SET_IS_AUTHORIZED,
            payload: { isAuthorized },
        });
        if (isAuthorized && !prevIsAuthorizedRef.current) {
            const authData = collectAuthData();
            helpers_1.ExtensionRuntime.sendMessage({
                type: constants_1.RegularMessage.SET_STORAGE,
                payload: { storage: authData },
            });
        }
        prevIsAuthorizedRef.current = isAuthorized;
    }, [isAuthorized]);
    const context = {};
    return (0, jsx_runtime_1.jsx)(exports.SessionContext.Provider, { value: context, children: children });
};
exports.SessionProvider = SessionProvider;
